import * as asyncStorage from 'loot-core/src/platform/server/asyncStorage';

export enum AsyncStorageKey {
  USER_DATA = 'user-data',
  USER_TOKEN = 'user-token',
  ONBOARDING_DATA = 'onboardingData',
  BACKUP_WARNING_DATE = `backupWarningDate-{budgetId}`,
  IS_DEMO_BOOTSTRAPPED = 'is-demo-bootstrapped',
  DEMO_BUDGET_START_DATE = 'demo-budget-start-date',
  HAS_REMOTE_ACCOUNT = 'has-remote-account',
  LAST_BANK_SYNC_DATE = 'last-bank-sync-date',
  MOBILE_DISCLAIMER_MODAL_LAST_SHOWN_DATE = 'mobile-disclaimer-modal-last-shown-date',
}

export function useStorage(key: AsyncStorageKey) {
  return {
    setItem,
    getItem,
    removeItem,
  };

  async function setItem(props) {
    await asyncStorage.setItem(key, props);
  }

  async function getItem(): Promise<any> {
    return await asyncStorage.getItem(key);
  }

  async function removeItem() {
    return await asyncStorage.removeItem(key);
  }
}
